/* eslint no-trailing-spaces: 0 */

const messages = {
  'params': {
    'label': 'English'
  },
  'service': {
    'flow-and-time': 'Qty of Water Flow & Time',
    'ro-membrane': 'RO Membrane Efficiency',
    'temperature': 'Temperature',
    'leakage': 'Leakage Detection',
    'pressure': 'Water Pressure',
    'co2': 'CO2 Gas'
  },
  'service-short': {
    'flow-and-time': 'WaterFlow&Time',
    'ro-membrane': 'RO',
    'temperature': 'Temperature',
    'leakage': 'Leakage',
    'pressure': 'Pressure',
    'co2': 'CO2'
  },
  'sensor': {
    'flow': 'Flow sensor',
    'tds': 'TDS sensor',
    'temperature': 'Temperature sensor',
    'leakage': 'Leakage sensor',
    'pressure': 'Pressure sensor'
  },
  'user-params': {
    username: 'Username',
    email: 'E-mail',
    password: 'Password',
    password_reinput: 'Password (reinput)',
    password_reinput_differs: 'Password and Password (reinput) are differ.',
    role: 'Role'
  },
  'role': {
    'administrator': 'Administrator',
    'manager': 'Manager',
    'staff': 'Staff'
  },
  'btn': {
    'add': 'Add',
    'edit': 'Edit',
    'cancel': 'Cancel',
    'update': 'Update',
    'save': 'save',
    'ok': 'OK',
    'delete': 'Delete',
    'resend': 'Resend'
  },
  'validate': {
    'phone-format': 'Please enter only digits',
    'phone-length': 'Phone number must be within 128 digits',
    'select': 'Please select',
    'vali-required': 'This field is required.'
  },
  cognitoError: {
    UserNotFoundException: 'Username is not found.',
    UsernameExistsException: 'User already exists.',
    UserNotConfirmedException: 'User is not confirmed.',
    NotAuthorizedException: 'Incorrect username or password.',
    LimitExceededException: 'Attempt limit exceeded, please try after some time.',
    CodeMismatchException: 'Invalid verification code provided, please try again.',
    InvalidParameterException: 'Invalid parameter is designated.',
    UnknownError: 'Detected unknown error at this service.'
  },
  signup: {
    signup: 'New User Registration',
    register: 'Register New User',
    btn_check_email: 'Please check e-mail',
    buy_iotizr: 'Buy IoTIZR',
    signupConfirmDialogText: 'Will you proceed?',
    signupSuccessDialogText: 
      'We received your new registration request. You will receive ' +
      'confirmation e-mail from no-reply@harps4.com at email address designated. Please click URL ' +
      'in the e-mail, then you will be registered correctly.',
    agreement_msg: 
      'By registering with Aplix, opening a HARPS account or using HARPS, ' +
      'you agree and consent to:' +
      '<ul>' +
      '<li>the <a href="http://www.aplix.co.jp/en/legal/terms_harps.php">HARPS Terms of Service</a>' +
      '<li>the collection and use of personal information as set forth in the ' +
        '<a href="http://www.aplix.co.jp/en/privacypolicy/privacypolicy_iot.php">Privacy Policy for IoT Solution</a>' +
      '<li>individualized mandatory binding arbitration for any disputes between us' +
      '<li>emails sent to you for account management purposes, and other purposes w/opt-out' +
      '</ul>'
  },
  'login': {
    'login': 'Login',
    'lost': 'Forgot your password?',
    'link_to_signup': 'Sign up',
    'vali-username-blank': 'Username is required.',
    'vali-password-blank': 'Password is required.',
    'next': 'Next',
    'incorrect': 'Incorrect username or password.'
  },
  'resetpassword': {
    'title': 'Reset Password',
    'detail': 'Please enter your Username',
    'entercode': 'Please enter verify code.',
    'newpassword': 'New Password',
    'codedetail': 'An email with a confirmation code has been sent from "no-reply@verificationemail.com" to your registered email address. Check your email and enter the confirmation code below.',
    'resendcode': 'Resend code',
    'vali-code-blank': 'Verification code is required.',
    'vali-pass-blank': 'New password is needed.',
    'vali-pass-number': 'Password must have at least number (0-9) and one letters (a-z).',
    'vali-pass-length': 'Password must be more than 7 characters.',
    'vali-pass-whitespace': 'Passwords containing spaces can not be set.',
    'confirm': 'Confirm'
  },
  activate: {
    title: 'Activate your account',
    detail: 'Check your email and enter the username and temporary password. And you need to change temporary passowrd. Please enter new password.',
    temp_password: 'Temporary Password',
    newpassword: 'New Password',
    passwordreinput: 'New Password (reinput)',
    agreement: 'Agreement',
    agreement_msg:
      'This service is brought to you by Aplix Corporation. By using this ' +
      'service, you agree and consent to the HARPS USERS Terms of Service ( ' +
      '<a href="http://www.aplix.co.jp/en/legal/terms_harpsusers.php" target="_blank">' +
      'HARPS USERS Terms of Service</a>, ' +
      '<a href="http://www.aplix.co.jp/en/privacypolicy/privacypolicy_iot.php" target="_blank">' +
      'Privacy Policy for IoT Solurion</a> ) ' +
      'and arbitration before the International Chamber of Commerce for any ' +
      'disputes between us.',
    agree: 'I have read and agree with these terms.',
    you_need_to_agree: 'You need to agree',
    submit: 'Submit',
    complete: 'Activate Complete'
  },
  'global-menu': {
    'dashboard': 'Home',
    'watersystem': 'Monitoring',
    'customer': 'Location Management',
    'setting': 'Settings',
    'pc': 'PC Management'
  },
  'home': {
    'notification': 'Notification',
    'information': 'From {0}',
    'mail-notification-top': 'Email notification is now available.',
    'mail-notification-under': 'please confirm your settings in <a href=\'{0}\'>here</a>',
    'quick-link': 'Quick Link',
    'calendar': 'Maintenance Calendar',
    'quick-link-settings': 'Quick Link Settings',
    'notification-alert': 'Alert value reached',
    'notification-warning': 'Warning value reached'
  },
  'watersystem': {
    'column-nexttime': 'Next replacement expectancy',
    'customer-name': 'Location name',
    'customer': 'Location',
    'organization-name': 'Organization',
    'device-name': 'Device name',
    'device': 'Device',
    'deviceinfo': 'Device Information',
    'filter-life-left': 'Filter life left',
    'filter': 'Filter',
    'flow-rate': 'Flow Rate',
    'flow': 'Flow',
    'history': 'History',
    'list': 'List by',
    'mapinfo': 'Map',
    'name': 'Name',
    'period-month': 'months',
    'purification-amount': 'amount of water purification',
    'RoMembrane': 'RO Membrane Removal Efficiency',
    'RoMembrane-short': 'RO Removal Rate',
    'RoMembrane-good': 'Good',
    'RoMembrane-caution': 'Warning',
    'RoMembrane-alert': 'Alert',
    'Pressure': 'Pressure sensor',
    'Pressure-short': 'Pressure sensor',
    'Pressure-good': 'Good',
    'Pressure-caution': 'Warning',
    'Pressure-alert': 'Alert',
    'service': 'Service',
    'status': 'Status',
    'delete-water-system': 'Delete {0}.\nAll history will be lost.',
    'delete-water-system-with-iotizr': 'Registered IoTIZR will continue to communicate but will not be able to read the data.\nIf you want to stop communication from IoTIZR, please unplug the power of IoTIZR or delete from HARPS Toolkit.',
    'delete-water-system-ask': 'Do you really want to delete this?',
    'error-delete': 'Failed to delete.',
    'succeed-delete': 'Delete Sucessfully',
    'filter-reset': 'Filter Reset',
    'please-select': 'Please select a device.',
    'elapsed-time': 'Elapsed Time',
    'total-flow': 'Qty of Water Flow',
    'customer-info': 'Location Info',
    'rest-flow': 'Remaining water flow Qty',
    'filter-reset-title': 'Warning!',
    'filter-reset-text': 'Are you sure you want to reset the Filter?',
    'filter-reset-do': 'Reset',
    'filter-reset-cancel': 'Cancel',
    'threshold': 'Threshold',
    'notification-threshold': 'Notification Threshold',
    'about-flow-and-time': 'About flow rate and time threshold',
    'about-ro-membrane': 'About RO Membrane Efficiency threshold',
    'about-temperature': 'About Temperature threshold',
    'about-pressure': 'About Water Pressure threshold',
    'custom': 'Custom',
    'use-preset': 'Use presets',
    'flow-life': 'Flow Life',
    'time-life': 'Time Life',
    'alert': 'Alert',
    'warning': 'Warning',
    'use-flow': 'Flow sensor to use',
    'need-sensor': 'Required sensors',
    'about-flow-and-time-text': 'Measure the amount of water flow in the pipe hose within a certain time. We will send a notice by passage of time, increase of flow rate.',
    'about-ro-membrane-text': 'At the inlet / outlet 2 inlets / outlets of the RO membrane, install a probe of the TDS sensor to measure impurity content and calculate the impurity removal rate of the RO membrane. We will send you a notice due to reduced impurity removal rate.',
    'about-pressure-text': 'Measure the pressure value at the sensor installation location. As far as the number of ports of IoTIZR is concerned, it is possible to install multiple. Send notification beyond specified pressure.',
    'about-temperature-text': 'Measure the temperature of the sensor installation location. As far as the number of ports of IoTIZR is concerned, it is possible to install multiple. Send notification beyond specified temperature.',
    'about-setting-flow-and-time-text': 'Set the threshold at which warning / warning notice is issued for flow rate ([UNIT]) and time (month) respectively.',
    'about-setting-ro-membrane-text': 'Set caution value / warning value with impurity removal rate (%).',
    'about-setting-temperature-text': 'Set caution value / warning value with the temperature value.',
    'about-setting-pressure-text': 'Set caution value / warning value with the pressure value.',
    'about-threshold-setting': 'About threshold setting',
    'headline-press-alert': 'The pressure value is lower than the warning value.',
    'headline-press-warning': 'The pressure value is lower than the caution value.',
    'headline-press-normal': 'At present, all pressure values are normal.',
    'headline-diff-press-alert': 'The differential pressure value is beyond the warning value.',
    'headline-diff-press-warning': 'The differential pressure value is beyond the caution value.',
    'headline-temperature-up-alert': 'The temperature value is higher than alert value.',
    'headline-temperature-up-warning': 'The temperature value is higher than warning value.',
    'headline-temperature-down-alert': 'The temperature value is lower than alert value.',
    'headline-temperature-down-warning': 'The temperature value is lower than warning value.',
    'now-pressure': 'Current pressure value',
    'vali-threshold-must': 'Required fields',
    'vali-threshold-num': 'Please enter with numeric value',
    'vali-threshold-min': 'It is below the measurable temperature.',
    'vali-threshold-max': 'It is above the measurable temperature.',
    'vali-threshold-min-comm': 'Please enter {0} or more.',
    'vali-threshold-max-comm': 'Please enter {0} or less.',
    'vali-threshold-integer': 'Please enter with integer value',
    'vali-threshold-limit100': 'Please enter a number up to 100',
    'vali-threshold-positive-integer': 'Please enter a number greater than or equal to 0',
    'impurities-removal-rate': 'Impurity removal rate',
    'entrance-impurity-content': 'The inlet-side impurity content',
    'exit-impurity-content': 'Outlet impurity content',
    'time-elapsed': 'Time Elapsed',
    'pressure': 'Water Pressure',
    'setting-link-text1': 'Please edit "Notification threshold" of ',
    'setting-link-text2': 'settings',
    'setting-link-text3': ' to change',
    'vali-threshold-alert-less-than': 'Please enter a value smaller than the alert value',
    'vali-threshold-greater-than-warning': 'Please enter a number larger than the warning value',
    'vali-threshold-warning-less-than': 'Please enter a value smaller than the warning value',
    'vali-threshold-greater-than-alert': 'Please enter a number larger than the alert value',
    'last-update': 'Last Update',
    'past-pressure': 'Pressure value at {0}',
    'last-update-for-chart': 'Last Update',
    'last-update-week-suffix-for-chart': 'the week of {0}',
    'last-impurities-removal-late': 'Current Impurity removal rate',
    'past-impurities-removal-late': 'Impurity removal rate at {0}',
    'differential-pressure': 'Differential pressure value(s)',
    'about-differential-pressure-text': 'Measure the pressure value of two points and calculate the difference (absolute value) of the pressure value. Send notification by increasing differential pressure.',
    'about-setting-differential-pressure-text': 'Set caution/alert threshold values of differential pressure.',
    'differential-pressure-need-sensor': 'Two pressure sensors',
    'differential-pressure-value': 'Differential pressure value',
    'leakage-all-normal': 'There is no water leakage right now',
    'return-to-normal': 'Return to no leak',
    'leakage-alert': 'Water leak',
    'detection-history': 'Water leak history',
    'no-water-leak-history': 'There is no water leak history.',
    'headline-leakage-alert': 'We are sensing water. Please check the location.',
    'leakage-normal': 'No leak',
    'leakage': 'Leakage sensor',
    'leakage-short': 'Leakage sensor',
    'temperature-short': 'Temperature sensor',
    'temperature-alert': 'Alert',
    'temperature-warning': 'Warning',
    'temperature-normal': 'No problem',
    'temperature-min': 'or more',
    'temperature-max': 'or less',
    'temperature-increase': 'Notification when a value is above threshold',
    'temperature-decrease': 'Notification when a value is below threshold',
    'temperature-content': 'Temperature',
    'temperature-select-label': 'Notification rule',
    'now-temperature': 'Current temperature value',
    'past-temperature': 'Current temperature at {0}'
  },
  'chart': {
    'dataZoom-zoom': 'Zoom',
    'dataZoom-back': 'Zoom Reset',
    'change-period': 'change period',
    'button-reload': 'Reload',
    'graph-label-fromlastchange': 'Total water purification since the last filter change',
    'graph-label-diff': 'Water purification during the period',
    'graph-label-sum': 'Total water purification',
    '15m': '15 minute',
    '1h': '1 hour',
    '1d': '1 day',
    '1w': '1 week',
    '1M': '1 month',
    'auto-reload': 'Auto Reload',
    'label-date': 'Date',
    'label-time': 'Time',
    'button-date-jump': 'Jump',
    'button-date-recent': 'Recent',
    'button-ok': 'Ok',
    'button-cancel': 'Cancel',
    'message-oldest': 'It\'s being indicated from the oldest data because data of designated date and time can\'t be shown to the center.',
    'message-latest': 'The latest data is being indicated because data of designated date and time can\'t be shown to the center.',
    'message-outbounds-oldest': 'It\'s being indicated from the oldest data because data of designated date and time doesn\'t exist.',
    'message-outbounds-latest': 'The latest data is being indicated because data of designated date and time doesn\'t exist.',
    'message-no-data': 'There is no data.'
  },
  'csv-download': {
    'button-csv-download': 'CSV Download',
    'button-download': 'Download',
    'start-datetime': 'Start Date Time',
    'end-datetime': 'End Date Time',
    'failed-download-no-data': 'Can\'t downlaad because no data',
    'failed-create-zip-file-fatal': 'It couldn\'t be downloaded because a fatal error occurred.',
    'failed-create-zip-file-busy': 'Server is busy. Please try again later.',
    'invalid-start-end-datetime': 'Invalid date. Start date time later than End date time.'
  },
  /* 英語統一のため使用しない2019/01/17R.Inoue
  'csv-header': {
    'datetime': 'Date time',
    'organization-name': 'Organization name',
    'location-name': 'Location name',
    'device-name': 'Devoce name',
    'flow-log-status': 'Water purification status',
    'flow-log-flow': 'Total water purification({0})',
    'flow-log-flow-diff': 'Water purification during the period({0})',
    'ro-rate-log-status': 'Impurity removal status',
    'ro-rate-log-rate': 'Impurity removal rate(%)',
    'temperature-log-status': '{0}:Temperature Status',
    'temperature-log-temperature': '{0}:Temperature({1})',
    'leakage-log-status': '{0}:Water leak status',
    'water-pressure-log-status': '{0}:Pressure Status',
    'water-pressure-log-pressure': '{0}:Pressure value({1})'
  },
  */
  'user': {
    'unselected': 'Please select organization.',
    'nodata': 'there is no user.',
    'username': 'Username',
    'email': 'Email',
    'role': 'Role',
    'edit-setting': 'Edit setting'
  },
  'organizations': {
    'title': 'organizations list',
    'button-add': 'Add organization',
    'button-add-pc': 'Add P/C Accounts',
    'vali-create-limit': 'Subordinate organization can not be created because it is restricted',
    'limit-settings': 'Organization creation limit',
    'no-limit': 'Unlimited'
  },
  'device': {
    'name': 'device name',
    'vali-device-name': 'device name is required.'
  },
  'settings': {
    'title': 'Settings',
    'unit': 'Unit of water quantity',
    'timezone': 'Timezone',
    'timezone-location': 'Local Timezone',
    'pressureUnit': 'Unit of pressure',
    'temperatureUnit': 'Unit of temperature',
    'display-setting': 'Display Setting',
    'available-sensor': 'Sensors',
    'life-and-notification': 'Life of consumables and Notification',
    'notification-presets': 'Notification presets',
    'notification-mail': 'Notification mail',
    'organization-user': 'Organization and user',
    'management-organization': 'Organization Management',
    'user-management': 'User Management',
    'user-invitation': 'Add User',
    'add-organization': 'Add Organization',
    'pc-management': 'P/C Management',
    'set-up': 'Update'
  },
  'account': {
    'delete-organization': 'Delete Organization',
    'basic-information': 'Basic information',
    'organization': 'Organization name',
    'parent-organization': 'Parent organization',
    'description': 'Description',
    'tel': 'Telephone',
    'email': 'Email',
    'contact': 'Contact',
    'incharge': 'the person in charge',
    'administrator': 'administrator',
    'name': 'Name(optional)',
    'username': 'Incharge username',
    'useremail': 'Incharge email',
    'company': 'Company Name',
    'address': 'Address',
    'created': 'Registered Date',
    'edit': 'Edit',
    'caution-title': 'Caution!',
    'caution-org-remove-text': 'Are you sure you want to delete the organization below?',
    'caution-user-remove-text': 'Are you sure you want to delete the user below?',
    'caution-location-remove-text': 'Are you sure you want to delete the location below?',
    'delete': 'Delete',
    'cancel': 'Cancel',
    'close': 'Close',
    'create': 'Create',
    'updated': 'Updated',
    'error-delete': 'Deletion failure.',
    'error-customer': 'There are related Location(s) remaing.',
    'error-user': 'There are some users under this.',
    'error-root': 'This is root organization.',
    'error-system': 'There are related systems remaing.',
    'header-title': 'Organization and User Management',
    'header-org': 'Organization Management',
    'header-user': 'User Management',
    'header-invite': 'Add User',
    'header-pc': 'P/C Management',
    'invite-btn': 'Send invitation email',
    'policy': 'Policy Statement',
    'agree': 'Agree',
    'csv-import': 'We are planning the CSV Import function',
    'label-role': 'Role',
    'label-parent': 'Parent Organization',
    'label-belongto': 'Organization',
    'label-organization': 'Organization',
    'label-account': 'Account',
    'label-username': 'Incharge username',
    'label-useremail': 'Incharge email',
    'success-dialog': 'Invite message was successfully sent.',
    'fail-dialog': 'Invite message was failed sent.',
    'vali-username-must': 'Username is required.',
    'vali-username-format': 'Must be alphabet, numeric and symbols (. - _ @)',
    'vali-username-char': 'Username must be 4-20 characters.',
    'vali-email-must': 'Email address is required.',
    'vali-email-format': 'Must be valid email',
    'vali-phone-format': 'only number is valid.',
    'vali-phone-length': 'phone must be within 128 numbers.',
    'vali-role': 'Please select',
    'vali-org-select': 'Please select',
    'vali-org-name': 'Organization name is required.',
    'vali-location-name': 'Location name is required',
    'fail-registration': 'Registration failed',
    'fail-username': 'The username entered can not be registered',
    'fail-master-name': 'The top level organization can not be changed',
    'fail-email-update': 'Failed to update email address.' +
    'If you have sent a message please discard it.',
    'can-edit-message': 'you can edit role and organization.',
    'cant-edit-yourself': 'You can\'t edit yourself.',
    'update-succeed': 'Update Sucessfully',
    'delete-succeed': 'Delete Sucessfully',
    'function-limit': 'Some functions can not be used with the current account.',
    'cant-delete-yourself': 'You can\'t delete yourself.',
    'cant-delete-admin-user': 'At least one super administrator user at the top level organization is required.',
    'delete-completed-myself': 'Deletion of your account has been completed.',
    'already-account': 'It is an already registered account. Please refresh the screen.'
  },
  'viewable-locations': {
    'header-viewable-locations': 'Visible Locations Management',
    'button-add-viewable-locations': 'Add Visible Locations',
    'label-permit-viewing-locations': 'Permit Visible Locations',
    'select-is-not-limited-viewer': 'All locations',
    'select-is-limited-viewer': 'Only selected locations',
    'label-viewing-target-locations': 'Visible Locations',
    'hint-viewing-target-locations': 'Pleese select visible locations',
    'button-set': 'Set',
    'button-cancel': 'Cancel'
  },
  'customer': {
    'add': 'Add Location',
    'latitude': 'Latitude',
    'longitude': 'Longitude',
    'info': 'Basic information',
    'situation': 'Usage Report',
    'active-device': 'Active Device',
    'others': 'Others',
    'geo-location': 'latitude/longitude',
    'defined': 'registered.',
    'undefined': 'undefined.',
    'situation-title': 'Summury',
    'print': 'Print',
    'target': 'Target',
    'sum': 'Sum',
    'history': 'History',
    'iotizr-situation': 'Situation of IoTIZR',
    'service-plan': 'Service plan',
    'device-customer': 'Device (Location)',
    'date': 'date',
    'name': 'Location name',
    'device': 'Device',
    'organization': 'Organization',
    'address': 'Address',
    'tel': 'Phone',
    'open-map': 'Get the numbers from map',
    'close-map': 'Close the map',
    'content': 'Content',
    'get-address': 'Get the address',
    'search': 'Search',
    'error-location': 'Can\'t get a Longitude and Latitude',
    'error-delete': 'Failed to delete.',
    'error-delete-connecting-device': 'Remove IoTIZR(s) of this location first with HARPS Toolkit and try again.',
    'success-delete': 'Delete Sucessfully.'
  },
  'notifications': {
    'header-title': 'Life of consumables and Notification',
    'header-preset': 'Notification presets',
    'header-mail': 'Notification mail',
    'title-mail': 'Notification mail',
    'title-langage': 'Language setting',
    'japanese': 'Japanese',
    'english': 'English',
    'russian': 'Russian',
    'enable': 'Receive',
    'disable': 'Not Receive'
  },
  'profile': {
    'profile': 'Your profile',
    'role': 'Role',
    'organization': 'Organization',
    'email': 'Email',
    'new-email': 'New Email',
    'change-email': 'Change Email',
    'change-password': 'Change Password',
    'old-password': 'Current Password',
    'new-password': 'New Password',
    'confirm-new-password': 'Confirm new Password',
    'cancel': 'Cancel',
    'change': 'Change',
    'submit': 'Submit',
    'confirm': 'Confirm',
    'resend': 'Resend email',
    'continue': 'Continue',
    'confirmation-code': 'Enter your confirmation code',
    'confirmation-code-input': 'Enter confirmation code',
    'change-password-error': 'Incorrect old password.',
    'not-verified': 'Your email is not verified',
    'verify': 'Verify',
    'verified': 'Your email is verified',
    'vali-blank-new-pass': 'Please enter the new password',
    'vali-blank-old-pass': 'Please enter the current password',
    'vali-blank-confirm-new-pass': 'Please enter the confirm new password',
    'vali-format': 'Must be at least 8 characters long and Must contain at least one number (0-9)',
    'vali-length': '2must be within 25 digits',
    'vali-same-password': 'Please enter the same password as above.',
    'vali-empty-code': 'Enter confirmation code',
    'vali-email-format': 'Please provide a valid email address',
    'vali-invalid-code': 'Confirmation code is wrong',
    'code-confirm-text1': 'An email with a confirmation code has been sent to your registered email address.',
    'code-confirm-text2': 'Check your email and enter the confirmation code below.',
    'code-confirm-title': 'Enter your confirmation code',
    'code-confirm-input': 'Confirmation code',
    'change-email-title': 'Change Email',
    'change-password-title': 'Change Password',
    'success-resend': 'An email with a confirmation code has been sent to your registered email address.\n In case the mail is not delivered, please try after some time.',
    'fail-resend': 'Resent failed',
    'fail-error': 'Attempt limit exceeded, please try after some time.',
    'changed-password': 'Your password is updated'
  },
  'aplix-use-only': {
    'customer-category': 'Customer category',
    'customer-categories': {
      '1': 'Unknown',
      '2': 'For testing',
      '3': 'Domestic customers',
      '4': 'Overseas customers'
    },
    'btn': {
      'can-not-execute': 'Can not execute',
      'can-not-save': 'Can not save',
      'can-not-delete': 'Can not delete'
    },
    'usage-report': {
      'pc-organization': 'P/C organization',
      'button-csv-download': 'CSV Download'
    }
  },
  'usage-report': {
    'organization-name': 'Organization',
    'target-date': 'Date',
    'date': 'Date',
    'print': 'Print',
    'total-device-count': 'Total',
    'units': ' IoTIZRs',
    'location-count-title': 'Organization/Location Classification',
    'location-count-list': {
      'organization-name': 'Organization',
      'location-name': 'Location',
      'device-count': 'Active IoTIZR'
    },
    'device-count-title': 'Individual Classification',
    'device-count-list': {
      'organization-name': 'Organization',
      'location-name': 'Location',
      'filtration-system-name': 'Device',
      'unique-id': 'IoTIZR ID'
    },
    'can-not-print-ios': 'iOS does not support printing',
    'no-data-text': 'Usage report will be updated around 2nd of the next month.',  
    'failed-display-no-data': 'Can\'t display because no data',
    'failed-download-no-data': 'Can\'t downlaad because no data',
    'failed-create-zip-file-fatal': 'It couldn\'t be downloaded because a fatal error occurred.',
    'failed-create-zip-file-busy': 'Server is busy. Please try again later.'
  }
}

module.exports = messages



// WEBPACK FOOTER //
// ./src/assets/aqua_harps4_com/translations/english.js